import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { ADD_MODAL as CCY_RATES_ADD_MODAL } from './constants'

const CCYRatesFormModal = Loadable(() => import('./CCYRates'))

export const createCCYRatesFormNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'chart2',
  text: translateFn('mnu_other_currency_rates'),
  identity: CCY_RATES_ADD_MODAL,
  permission: 'VIEW_CURRENCY_RATE',
  component: CCYRatesFormModal,
}))

export default CCYRatesFormModal
